<!-- Ghost Update Combination Confirmation Modal Component -->
<!-- Using shared confirmation modal component (Pattern 8) -->

<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="showModal"
  (confirmed)="onConfirm()"
  (cancelled)="onCancel()"
  (closed)="onCancel()">
</gtw-confirmation-modal>
